(function () {
  function syncCartCount() {
    var sourceCount = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    var count = sourceCount ? sourceCount.textContent.trim() : '0';
    document.querySelectorAll('[data-duovio-cart-count]').forEach(function (target) {
      target.textContent = count;
    });
  }

  function connectCartCount() {
    var source = document.querySelector('#cart-icon-bubble');
    if (!source || source.dataset.duovioObserved === 'true') return;
    source.dataset.duovioObserved = 'true';
    syncCartCount();
    new MutationObserver(syncCartCount).observe(source, { childList: true, subtree: true, characterData: true });
    document.addEventListener('cartQuantityUpdated', syncCartCount);
  }

  function showFormError(wrapper, message) {
    var error = wrapper.querySelector('.duovio-form-error');
    if (!error) return;
    error.hidden = !message;
    error.querySelector('span').textContent = message || '';
  }

  function setDrawerLoading(drawer, isLoading) {
    if (!drawer) return;
    drawer.classList.toggle('duovio-cart-loading', isLoading);
    if (isLoading) {
      drawer.setAttribute('aria-busy', 'true');
    } else {
      drawer.removeAttribute('aria-busy');
    }
  }

  async function submitProductForm(form, wrapper, button, directCheckout) {
      var variantField = form.querySelector('[name="id"], [data-duovio-variant-field]');
      if (variantField && !variantField.value) variantField.value = wrapper.dataset.duovioVariantId;
      if (variantField && variantField.hasAttribute('data-duovio-variant-field')) variantField.name = 'id';
      var drawer = document.querySelector('cart-drawer');
      var formData = new FormData(form);
      var variantId = variantField && variantField.value ? variantField.value : wrapper.dataset.duovioVariantId;
      formData.set('id', variantId);
      if (!formData.has('quantity')) formData.append('quantity', '1');
      if (!directCheckout && drawer && typeof drawer.getSectionsToRender === 'function') {
        formData.append('sections', drawer.getSectionsToRender().map(function (section) { return section.id; }));
        formData.append('sections_url', window.location.pathname);
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
      }
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;
      showFormError(wrapper, '');

      var shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeoutId = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 10000);

      if (!directCheckout && drawer && typeof drawer.open === 'function') {
        setDrawerLoading(drawer, true);
        drawer.open(button);
      }

      try {
        var response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body: formData,
          signal: controller ? controller.signal : undefined
        });
        var result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Nie udało się dodać produktu do koszyka.');
        }

        if (directCheckout) {
          window.location.assign(shopRoot + 'checkout');
          return;
        }

        if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
          drawer.renderContents(result, true);
          drawer.classList.remove('is-empty');
          var drawerInner = drawer.querySelector('.drawer__inner');
          if (drawerInner) drawerInner.classList.remove('is-empty');
          setDrawerLoading(drawer, false);
        } else {
          window.location.assign(shopRoot + 'cart');
          return;
        }

        window.setTimeout(syncCartCount, 100);
      } catch (error) {
        setDrawerLoading(drawer, false);
        if (error && error.name === 'AbortError') {
          window.location.assign(shopRoot + 'cart');
          return;
        }
        if (drawer && typeof drawer.close === 'function') drawer.close();
        showFormError(wrapper, error.message || 'Nie udało się dodać produktu do koszyka.');
      } finally {
        window.clearTimeout(timeoutId);
        button.removeAttribute('aria-disabled');
        button.disabled = false;
      }
  }

  function bindProductForm(form) {
    if (form.dataset.duovioBound === 'true') return;
    form.dataset.duovioBound = 'true';
    var wrapper = form.closest('.duovio-product-form-shell');
    var addButton = form.querySelector('[type="submit"]');
    var buyNowButton = form.querySelector('[data-duovio-buy-now]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitProductForm(form, wrapper, addButton, false);
    });

    if (buyNowButton) {
      buyNowButton.addEventListener('click', function () {
        submitProductForm(form, wrapper, buyNowButton, true);
      });
    }
  }

  function bindGallery(gallery) {
    if (gallery.dataset.duovioBound === 'true') return;
    gallery.dataset.duovioBound = 'true';
    gallery.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('[data-duovio-gallery-target]');
      if (!thumbnail) return;
      var targetId = thumbnail.dataset.duovioGalleryTarget;
      gallery.querySelectorAll('[data-duovio-gallery-slide]').forEach(function (slide) {
        slide.hidden = slide.dataset.duovioGallerySlide !== targetId;
      });
      gallery.querySelectorAll('[data-duovio-gallery-target]').forEach(function (button) {
        var isActive = button === thumbnail;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    });
  }

  function initializeDuovio() {
    document.querySelectorAll('.duovio-product-form').forEach(bindProductForm);
    document.querySelectorAll('[data-duovio-gallery]').forEach(bindGallery);
    connectCartCount();
  }

  if (!window.duovioCartListener) {
    window.duovioCartListener = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-duovio-cart-trigger]');
      if (!trigger) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open(trigger);
    });
    document.addEventListener('shopify:section:load', initializeDuovio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeDuovio, { once: true });
  } else {
    initializeDuovio();
  }
})();
